/* Independent enhancement: no dependency on main.js, jQuery or the legacy slider. */
if (!customElements.get('monument-home-hero')) {
  customElements.define('monument-home-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const on = (el, event, fn, extra = {}) => el.addEventListener(event, fn, { signal: this.controller.signal, ...extra });
      this.slides = [...this.querySelectorAll('.mg-hero__slide')];
      this.tabs = [...this.querySelectorAll('[data-slide]')];
      if (!this.slides.length) return;
      this.index = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches || this.dataset.autoplay !== 'true';
      this.delay = Math.max(5000, Number(this.dataset.speed) * 1000 || 7000);
      this.inView = true;
      this.hovered = false;
      this.focused = false;
      this.show(0);
      this.setAttribute('data-ready', '');
      const controls = this.querySelector('.mg-hero__controls');
      if (controls) controls.hidden = false;
      on(this, 'click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-slide')) this.show(Number(button.dataset.slide), true);
        if (button.dataset.action === 'next') this.show(this.index + 1, true);
        if (button.dataset.action === 'prev') this.show(this.index - 1, true);
        if (button.dataset.action === 'pause') { this.paused = !this.paused; if (!this.paused) { this.focused = false; this.hovered = false; } this.schedule(); }
      });
      on(this, 'keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key) || !event.target.closest('.mg-hero__controls')) return;
        event.preventDefault();
        const rtl = getComputedStyle(this).direction === 'rtl';
        let next = event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.index + ((event.key === 'ArrowRight') !== rtl ? 1 : -1);
        this.show(next, true);
        if (event.target.hasAttribute('data-slide')) this.tabs[this.index].focus();
      });
      on(this, 'pointerenter', e => { if (e.pointerType !== 'touch') { this.hovered = true; this.schedule(); } });
      on(this, 'pointerleave', () => { this.hovered = false; this.schedule(); });
      on(this, 'focusin', () => { this.focused = true; this.schedule(); });
      on(this, 'focusout', e => { if (!this.contains(e.relatedTarget)) { this.focused = false; this.schedule(); } });
      on(this, 'touchstart', e => { this.touch = { x: e.touches[0].clientX, y: e.touches[0].clientY }; }, { passive: true });
      on(this, 'touchend', e => {
        if (!this.touch) return;
        const dx = e.changedTouches[0].clientX - this.touch.x, dy = e.changedTouches[0].clientY - this.touch.y;
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.index + (dx < 0 ? 1 : -1), true);
        this.touch = null;
      }, { passive: true });
      on(document, 'visibilitychange', () => this.schedule());
      on(this.motion, 'change', () => { if (this.motion.matches) this.paused = true; this.schedule(); });
      on(document, 'shopify:block:select', e => {
        const i = this.slides.findIndex(s => s.dataset.blockId === e.detail?.blockId);
        if (i >= 0) { this.paused = true; this.show(i, true); }
      });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.schedule(); }, { threshold: .15 });
        this.observer.observe(this);
      }
      this.schedule();
    }
    show(index, user = false) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.toggleAttribute('data-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      this.tabs.forEach((tab, i) => { if (i === this.index) tab.setAttribute('aria-current', 'true'); else tab.removeAttribute('aria-current'); });
      const counter = this.querySelector('[data-current]');
      if (counter) counter.textContent = String(this.index + 1).padStart(2, '0');
      if (user) {
        this.paused = true;
        const status = this.querySelector('[data-hero-status]');
        if (status) status.textContent = `${this.index + 1} of ${this.slides.length}: ${this.slides[this.index].querySelector('h2')?.textContent || ''}`;
      }
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      this.toggleAttribute('data-paused', this.paused);
      this.querySelector('[data-action="pause"]')?.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
      if (!this.paused && !this.focused && !this.hovered && this.inView && !document.hidden && this.slides.length > 1) this.timer = setTimeout(() => this.show(this.index + 1), this.delay);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
    }
  });
}
